export default __webpack_public_path__ + "static/media/BanIcon.827b2f22.svg";